<wr-base-dialog status="info" header="Vorlage importieren" [submitResponse]="onSubmit" [tooltip]="toolTip">
  <label class="label">Vorlage auswählen </label>
  <nb-select fullWidth [(ngModel)]="selectedTemplateId" class="template-select">
    <nb-option [value]="''">Keine Vorlage</nb-option>
    <nb-option *ngFor="let template of templates()" [value]="template.id">{{ template.name }}</nb-option>
  </nb-select>
  <label class="label" >Gebäudeteile auswählen</label>
  <div class="select-all-section">
    <nb-checkbox
      [className]="'Alle auswählen'"
      [checked]="selectAll"
      (checkedChange)="onSelectAllChange($event)"
    >Alle auswählen</nb-checkbox>
  </div>
  <div class="select-building-section" *ngFor="let section of buildingSections">
    <nb-checkbox
      [checked]="selectedBuildingSectionIds.includes(section.id)"
      (checkedChange)="onSectionCheckboxChange(section.id, $event)"
    >
      {{ section.sectionText }}
    </nb-checkbox>
  </div>
</wr-base-dialog>
